import React, { FC } from 'react';
import './styles.scss';

const TotalRow: FC<TotalRowProps> = ({ children, value, ...rest }) => (
  <div className='total-row' {...rest}>
    <span className='total-row__text'>{children}</span>
    <span className='total-row__value'>{value}</span>
  </div>
);

interface TotalRowProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  value: string;
}

export default TotalRow;
